const STORAGE_KEY = "westmarches:notebookHintSeen";

/**
 * The user opened the notebook (or otherwise dismissed the hint). After this
 * the blinking visual around the toolbar notebook icon should not return.
 */
export function markNotebookHintSeen(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, "1");
  } catch {
    // localStorage may be unavailable (private mode, quota); fall back to a
    // best-effort, non-persisted dismissal.
  }
}

export function hasSeenNotebookHint(): boolean {
  if (typeof window === "undefined") return true;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return true;
  }
}
